<!-- 信息表单 -->
<template>
  <div class='info_form_wrap'>
    <!-- 称呼 -->
    <div
      class="info_form_item"
      :style="{marginBottom:`${formSty.el_margin}px`,overflow: 'hidden',borderRadius: `${formSty.el_radius}px`}"
    >
      <div
        class="form_item_name"
        :class="rules.b7igxspft.required ? 'item_need' : ''"
      >{{labels.b7igxspft}}</div>
      <div class="form_item_divider"></div>
      <van-field label="">
        <template #input>
          <van-radio-group
            class="form_radio_group_wrap"
            v-model="form.b7igxspft"
          >
            <van-radio
              class="form_radio_item"
              :name="item.label"
              v-for="item of options.title"
              :key="item.value"
            >{{ item.label }}</van-radio>
          </van-radio-group>
        </template>
      </van-field>
    </div>
    <!-- 姓 -->
    <div
      class="info_form_item"
      :style="{marginBottom:`${formSty.el_margin}px`,overflow: 'hidden',borderRadius: `${formSty.el_radius}px`}"
    >
      <div
        class="form_item_name"
        :class="rules.er4enn2mq.required ? 'item_need' : ''"
      >{{labels.er4enn2mq}}</div>
      <div class="form_item_divider"></div>
      <van-field
        v-model="form.er4enn2mq"
        :error="rules.er4enn2mq.error"
        placeholder="请输入"
      />
    </div>
    <!-- 名 -->
    <div
      class="info_form_item"
      :style="{marginBottom:`${formSty.el_margin}px`,overflow: 'hidden',borderRadius: `${formSty.el_radius}px`}"
    >
      <div
        class="form_item_name"
        :class="rules.iaqcdggeb.required ? 'item_need' : ''"
      >{{labels.iaqcdggeb}}</div>
      <div class="form_item_divider"></div>
      <van-field
        v-model="form.iaqcdggeb"
        :error="rules.iaqcdggeb.error"
        placeholder="请输入"
      />
    </div>
    <!-- 性别 -->
    <div
      class="info_form_item"
      :style="{marginBottom:`${formSty.el_margin}px`,overflow: 'hidden',borderRadius: `${formSty.el_radius}px`}"
    >
      <div
        class="form_item_name"
        :class="rules.iaqclkx89.required ? 'item_need' : ''"
      >{{labels.iaqclkx89}}</div>
      <div class="form_item_divider"></div>
      <van-field label="">
        <template #input>
          <van-radio-group
            class="form_radio_group_wrap"
            v-model="form.iaqclkx89"
          >
            <van-radio
              class="form_radio_item"
              :name="item.label"
              v-for="item of options.gender"
              :key="item.value"
            >{{ item.label }}</van-radio>
          </van-radio-group>
        </template>

      </van-field>
    </div>
    <!-- 单位 -->
    <div
      class="info_form_item"
      :style="{marginBottom:`${formSty.el_margin}px`,overflow: 'hidden',borderRadius: `${formSty.el_radius}px`}"
    >
      <div
        class="form_item_name"
        :class="rules.company_name.required ? 'item_need' : ''"
      >{{labels.company_name}}</div>
      <div class="form_item_divider"></div>
      <van-field
        v-model="form.company_name"
        :error="rules.company_name.error"
        placeholder="请输入"
      />
    </div>
    <!-- 手机号 -->
    <div
      class="info_form_item"
      :style="{marginBottom:`${formSty.el_margin}px`,overflow: 'hidden',borderRadius: `${formSty.el_radius}px`}"
    >
      <div
        class="form_item_name"
        :class="rules.mobile_phone.required ? 'item_need' : ''"
      >{{labels.mobile_phone}} <span class="form_item_name_desc">(非大陆地区手机号，请填写您本地区区号)</span></div>
      <div class="form_item_divider"></div>
      <van-cell-group class="form_phone_num_wrap">
        <van-field
          class="form_phone_code"
          v-model="form.country_code"
          :error="rules.country_code.error"
          type="number"
          placeholder="国别区号"
          @input="countryCodeInp"
        />
        <van-field
          class="form_phone_number"
          v-model="form.mobile_phone"
          :error="rules.mobile_phone.error"
          type="number"
          placeholder="请输入"
          @input="mobilePhoneInp"
        />
      </van-cell-group>
    </div>
    <!-- 邮箱 -->
    <div
      class="info_form_item"
      :style="{marginBottom:`${formSty.el_margin}px`,overflow: 'hidden',borderRadius: `${formSty.el_radius}px`}"
    >
      <div
        class="form_item_name"
        :class="rules.email.required ? 'item_need' : ''"
      >{{labels.email}}</div>
      <div class="form_item_divider"></div>
      <van-field
        v-model="form.email"
        :error="rules.email.error"
        placeholder="请输入"
        @input="emailInp"
      />
    </div>
    <!-- 地区 -->
    <div
      class="info_form_item"
      :style="{marginBottom:`${formSty.el_margin}px`,overflow: 'hidden',borderRadius: `${formSty.el_radius}px`}"
    >
      <div
        class="form_item_name"
        :class="rules.wh65wgvx6.required ? 'item_need' : ''"
      >{{labels.wh65wgvx6}}</div>
      <div class="form_item_divider"></div>
      <van-field label="">
        <template #input>
          <van-radio-group
            class="form_radio_group_wrap"
            v-model="form.wh65wgvx6"
            @change="addressChanged"
          >
            <van-radio
              class="form_radio_item"
              :name="item.label"
              v-for="item of options.region"
              :key="item.value"
            >
              <template #default>
                <div class="radio_item_wrap">
                  <div class="radio_item_text">{{ item.label }}</div>
                  <div class="radio_item_intro">{{item.desc}}</div>
                </div>
              </template>
            </van-radio>
          </van-radio-group>
        </template>

      </van-field>
    </div>

    <!-- 参会形式 -->
    <div
      class="info_form_item"
      :style="{marginBottom:`${formSty.el_margin}px`,overflow: 'hidden',borderRadius: `${formSty.el_radius}px`}"
    >
      <div
        class="form_item_name"
        :class="rules.lucabkzch.required ? 'item_need' : ''"
      >{{labels.lucabkzch}}</div>
      <div class="form_item_divider"></div>
      <van-field label="">
        <template #input>
          <van-radio-group
            class="form_radio_group_wrap"
            v-model="form.lucabkzch"
            :disabled="form.wh65wgvx6 == '中国大陆（Mainland China）'"
          >
            <van-radio
              class="form_radio_item"
              :name="item.label"
              v-for="item of options.participation"
              :key="item.value"
            >
              <template #default>
                <div class="radio_item_wrap">
                  <div class="radio_item_text">{{ item.label }}</div>
                  <div class="radio_item_intro">{{item.desc}}</div>
                </div>
              </template>
            </van-radio>
          </van-radio-group>
        </template>

      </van-field>
    </div>
    <!-- 种类 -->
    <div
      class="info_form_item"
      :style="{marginBottom:`${formSty.el_margin}px`,overflow: 'hidden',borderRadius: `${formSty.el_radius}px`}"
    >
      <div
        class="form_item_name"
        :class="rules.b7ih670y2.required ? 'item_need' : ''"
      >{{labels.b7ih670y2}}</div>
      <div class="form_item_divider"></div>
      <van-field label="">
        <template #input>
          <van-radio-group
            class="form_radio_group_wrap"
            v-model="form.b7ih670y2"
            @change="categoryChanged"
          >
            <van-radio
              class="form_radio_item"
              :name="item.label"
              v-for="item of options.category"
              :key="item.value"
            >{{ item.label }}</van-radio>
          </van-radio-group>
        </template>

      </van-field>
    </div>
    <!-- 学生证 -->
    <div
      class="info_form_item form_upload_img_wrap"
      :style="{marginBottom:`${formSty.el_margin}px`,overflow: 'hidden',borderRadius: `${formSty.el_radius}px`}"
      v-show="form.b7ih670y2 === '学生（Student）'"
    >
      <div
        class="form_item_name"
        :class="rules.sxk5rg2fh.required ? 'item_need' : ''"
      >{{labels.sxk5rg2fh}}</div>
      <div class="form_item_divider"></div>
      <van-field label="">
        <template #input>
          <van-uploader
            :before-read="BeforeImgUpload"
            :after-read="UploadImgToServer"
            :fileList="fileList"
            :before-delete="BeforeImgDelete"
            :max-count="1"
            class="business_card_uploader"
          >
            <div class="bcard_upload_btn">
              <div class="bcard_upload_btn_body">
                <div class="bcard_upload_icon_wrap">
                  <van-icon
                    color="#dcdee0"
                    name="photo"
                    class="bcard_upload_icon"
                  />
                </div>
              </div>
            </div>
          </van-uploader>
          <div
            v-show="uploading"
            class="bcard_preview_load_wrap"
          >
            <van-loading
              class="bcard_loading"
              size="24px"
              vertical
            >Upload...</van-loading>
          </div>
        </template>
      </van-field>
    </div>
    <!-- IEEE会员 -->
    <div
      class="info_form_item"
      :style="{marginBottom:`${formSty.el_margin}px`,overflow: 'hidden',borderRadius: `${formSty.el_radius}px`}"
    >
      <div
        class="form_item_name"
        :class="rules.sxk5r9tdc.required ? 'item_need' : ''"
      >{{labels.sxk5r9tdc}}</div>
      <div class="form_item_divider"></div>
      <van-field label="">
        <template #input>
          <van-radio-group
            class="form_radio_group_wrap"
            v-model="form.sxk5r9tdc"
            @change="isIeeeMemberChange"
          >
            <van-radio
              class="form_radio_item"
              :name="item.label"
              v-for="item of options.is_whether"
              :key="item.value"
            >{{ item.label }}</van-radio>
          </van-radio-group>
        </template>

      </van-field>
    </div>
    <!-- IEEE会员号 -->
    <div
      class="info_form_item"
      v-show="form.sxk5r9tdc === '是（Yes）'"
      :style="{marginBottom:`${formSty.el_margin}px`,overflow: 'hidden',borderRadius: `${formSty.el_radius}px`}"
    >
      <div
        class="form_item_name"
        :class="rules.b7ih6a35t.required ? 'item_need' : ''"
      >{{labels.b7ih6a35t}}</div>
      <div class="form_item_divider"></div>
      <van-field
        v-model="form.b7ih6a35t"
        :error="rules.b7ih6a35t.error"
        placeholder="请输入"
      />
    </div>
    <!-- 论文是否录用 -->
    <div
      class="info_form_item"
      :style="{marginBottom:`${formSty.el_margin}px`,overflow: 'hidden',borderRadius: `${formSty.el_radius}px`}"
    >
      <div
        class="form_item_name"
        :class="rules.iaqclybxj.required ? 'item_need' : ''"
      >{{labels.iaqclybxj}}</div>
      <div class="form_item_divider"></div>
      <van-field label="">
        <template #input>
          <van-radio-group
            class="form_radio_group_wrap"
            v-model="form.iaqclybxj"
            @change="isManuscriptChange"
          >
            <van-radio
              class="form_radio_item"
              :name="item.label"
              v-for="item of options.is_have"
              :key="item.value"
            >{{ item.label }}</van-radio>
          </van-radio-group>
        </template>

      </van-field>
    </div>
    <!-- 论文数量 -->
    <div
      class="info_form_item form_picker_wrap"
      v-show="form.iaqclybxj === '有（Yes）'"
      :style="{marginBottom:`${formSty.el_margin}px`,overflow: 'hidden',borderRadius: `${formSty.el_radius}px`}"
    >
      <div
        class="form_item_name"
        :class="rules.iaqclzke3.required ? 'item_need' : ''"
      >{{labels.iaqclzke3}}</div>
      <div class="form_item_divider"></div>
      <van-field
        v-model="form.iaqclzke3"
        placeholder="请选择"
        readonly
        @click="handlePick"
      />
    </div>
    <!-- 论文信息 -->
    <div
      class="paper_info_wrap"
      v-show="form.koo1lodu.length != 0"
      :style="{marginBottom:`${formSty.el_margin}px`,borderRadius: `${formSty.el_radius}px`}"
    >
      <div
        class="paper_info_item"
        v-for="(item, index ) of form.koo1lodu"
        :key="index"
      >
        <!-- 论文id -->
        <div
          class="info_form_item paper_info_form_item"
          :style="{marginBottom:`10px`,overflow: 'hidden',borderRadius: `${formSty.el_radius}px`}"
        >
          <div class="form_item_name item_need">{{item.name}}</div>
          <div class="form_item_divider"></div>
          <van-field
            v-model="item.paperid"
            placeholder="请输入"
          />
        </div>
        <!-- 报告方式 -->
        <div
          class="info_form_item paper_info_form_item"
          :style="{marginBottom:`10px`,overflow: 'hidden',borderRadius: `${formSty.el_radius}px`}"
          v-show="false"
        >
          <div class="form_item_name item_need">报告方式/Presentation Format</div>
          <div class="form_item_divider"></div>
          <van-field label="">
            <template #input>
              <van-radio-group
                class="form_radio_group_wrap"
                v-model="item.format"
              >
                <van-radio
                  class="form_radio_item"
                  :name="item.label"
                  v-for="item of options.format"
                  :key="item.value"
                >{{ item.label }}</van-radio>
              </van-radio-group>
            </template>

          </van-field>
        </div>
        <!-- 是否刊登 -->
        <div
          class="info_form_item paper_info_form_item"
          :style="{overflow: 'hidden',borderRadius: `${formSty.el_radius}px`}"
        >
          <div class="form_item_name item_need">是否在IEEE上刊登/Published on IEEE</div>
          <div class="form_item_divider"></div>
          <van-field label="">
            <template #input>
              <van-radio-group
                class="form_radio_group_wrap"
                v-model="item.is_publish"
              >
                <van-radio
                  class="form_radio_item"
                  :name="item.label"
                  v-for="item of options.is_whether"
                  :key="item.value"
                >{{ item.label }}</van-radio>
              </van-radio-group>
            </template>

          </van-field>
        </div>
      </div>
    </div>
    <!-- 支付币种 -->
    <div
      class="info_form_item"
      :style="{marginBottom:`${formSty.el_margin}px`,overflow: 'hidden',borderRadius: `${formSty.el_radius}px`}"
    >
      <div
        class="form_item_name"
        :class="rules.er4evwcmk.required ? 'item_need' : ''"
      >{{labels.er4evwcmk}}</div>
      <div class="form_item_divider"></div>
      <van-field label="">
        <template #input>
          <van-radio-group
            class="form_radio_group_wrap"
            v-model="form.er4evwcmk"
          >
            <van-radio
              class="form_radio_item"
              :name="item.label"
              v-for="item of options.currency"
              :key="item.value"
            >{{ item.label }}</van-radio>
          </van-radio-group>
        </template>

      </van-field>
    </div>

    <!-- 开票单位名称 -->
    <div
      class="info_form_item"
      v-show="form.wh65wgvx6 === '中国大陆（Mainland China）'"
      :style="{marginBottom:`${formSty.el_margin}px`,overflow: 'hidden',borderRadius: `${formSty.el_radius}px`}"
    >
      <div
        class="form_item_name"
        :class="rules.wh63hap7e.required ? 'item_need' : ''"
      >{{labels.wh63hap7e}}</div>
      <div class="form_item_divider"></div>
      <van-field
        v-model="form.wh63hap7e"
        :error="rules.wh63hap7e.error"
        placeholder="请输入"
      />
    </div>
    <!-- 开票单位纳税人识别号 -->
    <div
      class="info_form_item"
      v-show="form.wh65wgvx6 === '中国大陆（Mainland China）'"
      :style="{marginBottom:`${formSty.el_margin}px`,overflow: 'hidden',borderRadius: `${formSty.el_radius}px`}"
    >
      <div
        class="form_item_name"
        :class="rules.er4ew9r16.required ? 'item_need' : ''"
      >{{labels.er4ew9r16}}</div>
      <div class="form_item_divider"></div>
      <van-field
        v-model="form.er4ew9r16"
        :error="rules.er4ew9r16.error"
        placeholder="请输入"
      />
    </div>
    <!-- 开票单位地址 -->
    <div
      class="info_form_item"
      v-show="form.wh65wgvx6 === '中国大陆（Mainland China）'"
      :style="{marginBottom:`${formSty.el_margin}px`,overflow: 'hidden',borderRadius: `${formSty.el_radius}px`}"
    >
      <div
        class="form_item_name"
        :class="rules.er4ewaf8w.required ? 'item_need' : ''"
      >{{labels.er4ewaf8w}}</div>
      <div class="form_item_divider"></div>
      <van-field
        v-model="form.er4ewaf8w"
        :error="rules.er4ewaf8w.error"
        type="textarea"
        placeholder="请输入"
      />
    </div>
    <!-- 开票单位电话 -->
    <div
      class="info_form_item"
      v-show="form.wh65wgvx6 === '中国大陆（Mainland China）'"
      :style="{marginBottom:`${formSty.el_margin}px`,overflow: 'hidden',borderRadius: `${formSty.el_radius}px`}"
    >
      <div
        class="form_item_name"
        :class="rules.pdy81puhb.required ? 'item_need' : ''"
      >{{labels.pdy81puhb}}</div>
      <div class="form_item_divider"></div>
      <van-field
        v-model="form.pdy81puhb"
        :error="rules.pdy81puhb.error"
        placeholder="请输入"
      />
    </div>
    <van-popup
      v-model="ispick"
      :get-container="getContainer"
      position="bottom"
    >
      <van-picker
        show-toolbar
        :columns="options.paper_num"
        @cancel="onCancel"
        @confirm="onConfirm"
      />
    </van-popup>
    <!-- 页面底部 -->
    <div
      class="footer_wrap"
      v-show="footershow"
    >
      <div class="price_warp">
        <div class="price_text">注册费：</div>
        <div class="price_num">{{register_price}}</div>
      </div>
      <van-button
        class="footer_btn"
        type="primary"
        plain
        :color="formSty.button.bg_color"
        :style="{borderRadius: `${formSty.button.redius}px`}"
        @click="handleWannaPay"
      >注册</van-button>
      <!-- disabled -->
    </div>

    <!-- 支付方式选择 -->
    <PaymentWay
      :show="wannapay"
      :payment="payment"
      @listenClosePickPaymentMethod="closePaymentPicker"
      @listenPickedPaymentWay="pickedPaymentWay"
    />
    <!-- 创建订单时存在 未支付订单 -->
    <van-dialog
      v-model="waitPay"
      title="温馨提示"
      :message="'您还有未支付订单'"
      show-cancel-button
      :cancelButtonText="'取消订单'"
      :cancelButtonColor="'#f50'"
      :confirmButtonText="'前往支付'"
      :confirmButtonColor="'#069'"
      @confirm="wannaPayAgain"
      @cancel="wannaCancleOrder"
    >
    </van-dialog>

    <!-- 页面加载时查询时 存在未支付订单 -->
    <van-dialog
      v-model="nopaidOrder"
      title="温馨提示"
      :message="'您还有未支付订单'"
      show-cancel-button
      :cancelButtonText="'取消订单'"
      :cancelButtonColor="'#f50'"
      :confirmButtonText="'前往支付'"
      :confirmButtonColor="'#069'"
      @confirm="wannaPayOrder"
      @cancel="wannaCancelOrder"
    >
    </van-dialog>
    <!-- 加载中 -->
    <Loading :show="loading" />
  </div>
</template>

<script>
import { UploadAuthentication } from '@a/js/api/public'
import { UploadYun } from '@a/js/api/uploadyun'
import { ObjectDeepClone } from '@a/js/utils'
import { CreateOrder, CancleOrder, GetOrderStatuscom } from '@a/js/api/ieee'
import Loading from '@c/Loading'
import apiObj from '@a/js/api'
import PaymentWay from './paymentWay'
export default {
  name: 'InfoForm',
  props: {
    formSty: {
      type: Object,
      default: () => ({
        layout: 'vertical',
        el_radius: 0,
        el_margin: 10,
        button: {
          redius: 10,
          text: '确认提交',
          bg_color: '#06f',
          color: '#fff'
        },
      })
    },
    serveTime: {
      type: String,
      default: ''
    },
    footershow: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      apiObj,
      fileList: [],
      org_pagers: {
        paper1: {
          name: 'Paper1 ID',
          paperid: '',
          format: '',
          is_publish: ''
        },
        paper2: {
          name: 'Paper2 ID',
          paperid: '',
          format: '',
          is_publish: ''
        },
        paper3: {
          name: 'Paper3 ID',
          paperid: '',
          format: '',
          is_publish: ''
        },
        paper4: {
          name: 'Paper4 ID',
          paperid: '',
          format: '',
          is_publish: ''
        },
      },
      form: {
        b7igxspft: '', // "称呼/Title"
        er4enn2mq: '', // "姓/Last Name"
        iaqcdggeb: '', // "名/First Name"
        iaqclkx89: '',// "性别/Gender"
        company_name: '', // "单位/Institution"
        mobile_phone: '', // "联系电话/Phone"
        country_code: '86', // "国别区号"
        email: '', // "邮箱/Email"
        wh65wgvx6: '', // "地区/Region"
        lucabkzch: '', // "参会形式/Participation"
        b7ih670y2: '', // "种类/Categories"
        sxk5rg2fh: '', // "学生证明/Student Proof"
        sxk5r9tdc: '', // "IEEE会员/IEEE Member"
        b7ih6a35t: '', // "IEEE会员号/IEEE Member No."
        iaqclybxj: '', // "论文是否录用/Manuscript"
        iaqclzke3: 0, // "论文数量/No. of papers"
        er4evwcmk: '人民币（￥）', // "支付币种/Currency"
        wh63hap7e: '', // "开票单位名称"
        er4ew9r16: '', // "开票单位纳税人识别号"
        er4ewaf8w: '', // "开票单位地址"
        pdy81puhb: '', // "开票单位电话"
        koo1lodu: [], //"论文信息"
      },
      rules: {
        b7igxspft: {
          required: true,
          error: false
        },
        er4enn2mq: {
          required: true,
          error: false
        },
        iaqcdggeb: {
          required: true,
          error: false
        },
        iaqclkx89: {
          required: true,
          error: false
        },
        company_name: {
          required: true,
          error: false
        },
        mobile_phone: {
          required: true,
          error: false
        },
        country_code: {
          required: true,
          error: false
        },
        email: {
          required: true,
          error: false
        },
        wh65wgvx6: {
          required: true,
          error: false
        },
        lucabkzch: {
          required: true,
          error: false
        },
        b7ih670y2: {
          required: true,
          error: false
        },
        sxk5rg2fh: {
          required: true,
          error: false
        },
        sxk5r9tdc: {
          required: true
        },
        b7ih6a35t: {
          required: false,
          error: false
        },
        iaqclybxj: {
          required: true,
          error: false
        },
        iaqclzke3: {
          required: true,
          error: false
        },
        er4evwcmk: {
          required: true,
          error: false
        },
        wh63hap7e: {
          required: false,
          error: false
        },
        er4ew9r16: {
          required: false,
          error: false
        },
        er4ewaf8w: {
          required: false,
          error: false
        },
        pdy81puhb: {
          required: false,
          error: false
        },
        koo1lodu: {
          required: false,
          error: false
        },
      },
      labels: {
        b7igxspft: '称呼/Title',
        er4enn2mq: '姓/Last Name',
        iaqcdggeb: '名/First Name',
        iaqclkx89: '性别/Gender',
        company_name: '单位/Institution',
        mobile_phone: '联系电话/Phone',
        country_code: '国别区号',
        email: '邮箱/Email',
        wh65wgvx6: '地区/Region',
        lucabkzch: '参会形式/Participation',
        b7ih670y2: '种类/Categories',
        sxk5rg2fh: '学生证明/Student Proof',
        sxk5r9tdc: 'IEEE会员/IEEE Member',
        b7ih6a35t: 'IEEE会员号/IEEE Member No.',
        iaqclybxj: '论文是否录用/Manuscript',
        iaqclzke3: '论文数量/No. of papers',
        er4evwcmk: '支付币种/Currency',
        wh63hap7e: '开票单位名称',
        er4ew9r16: '开票单位纳税人识别号',
        er4ewaf8w: '开票单位地址',
        pdy81puhb: '开票单位电话',
      },
      options: {
        title: [
          {
            label: "Prof.",
            value: "eqkvhtleb"
          },
          {
            label: "Dr.",
            value: "ltsqxg334"
          },
          {
            label: "Mr.",
            value: "ia6t7n6o5"
          },
          {
            label: "Ms.",
            value: "wh638nqyl"
          },
          {
            label: "Mrs.",
            value: "luca38ldh"
          }
        ],
        gender: [
          {
            label: "男（Male）",
            value: "eqkvhtleb"
          },
          {
            label: "女（Female）",
            value: "ltsqxg334"
          }
        ],
        region: [
          {
            label: "中国大陆（Mainland China）",
            value: "eqkvhtleb",
            desc: "(中国大陆地区可提供发票，Invoice provided)"
          },
          {
            label: "港澳台（Hong Kong、Macau、Taiwan）",
            value: "ltsqxg334",
            desc: "(港澳台无法开具普票，仅提供收据，Receipt provided)"
          },
          {
            label: "其他国家（Other Countires）",
            value: "ttsqxg366",
            desc: "(国外无法开具普票，仅提供收据，Receipt provided)"
          }
        ],
        participation: [
          {
            label: "线上（Online）",
            value: "eqkvhtleb",
            desc: "(仅对非中国大陆地区提供)"
          },
          {
            label: "线下（Onsite）",
            value: "ltsqxg334"
          }
        ],
        category: [
          {
            label: "普通（Regular）",
            value: "eqkvhtleb"
          }, {
            label: "学生（Student）",
            value: "ltsqxg334"
          }
        ],
        is_whether: [
          {
            label: "是（Yes）",
            value: "eqkvhtleb"
          },
          {
            label: "否（No）",
            value: "ltsqxg334"
          }
        ],
        is_have: [
          {
            label: "有（Yes）",
            value: "eqkvhtleb"
          },
          {
            label: "无（No）",
            value: "ltsqxg334"
          }
        ],
        currency: [
          {
            label: "人民币（￥）",
            value: "eqkvhtleb"
          },
          {
            label: "美元（＄）",
            value: "ltsqxg334"
          }
        ],
        paper_num: [1],
        format: [
          {
            label: "口头（Oral）",
            value: "oral"
          },
          {
            label: "海报（Poster）",
            value: "poster"
          }
        ],
      },
      uploading: false,
      ispick: false,
      wannapay: false,
      // payment: [
      //   'wxpay',
      //   'alipay',
      //   'offline'
      // ],
      pricePrev: '',
      priceObj: {
        earlyBird: {
          //早鸟/标准+线上/线下  + 身份类型    + 是否会员 + 论文是否录用 + 论文数量
          "Early Bird线上（Online）学生（Student）否（No）无（No）0": 0,
          "Early Bird线上（Online）学生（Student）否（No）有（Yes）1": 1100,
          "Early Bird线上（Online）学生（Student）是（Yes）无（No）0": 0,
          "Early Bird线上（Online）学生（Student）是（Yes）有（Yes）1": 800,
          "Early Bird线上（Online）普通（Regular）否（No）无（No）0": 0,
          "Early Bird线上（Online）普通（Regular）否（No）有（Yes）1": 1350,
          "Early Bird线上（Online）普通（Regular）否（No）有（Yes）2": 2700,
          "Early Bird线上（Online）普通（Regular）否（No）有（Yes）3": 4050,
          "Early Bird线上（Online）普通（Regular）否（No）有（Yes）4": 5400,
          "Early Bird线上（Online）普通（Regular）是（Yes）无（No）0": 0,
          "Early Bird线上（Online）普通（Regular）是（Yes）有（Yes）1": 1050,
          "Early Bird线上（Online）普通（Regular）是（Yes）有（Yes）2": 1050,
          "Early Bird线上（Online）普通（Regular）是（Yes）有（Yes）3": 2050,
          "Early Bird线上（Online）普通（Regular）是（Yes）有（Yes）4": 2050,

          "Early Bird线下（Onsite）学生（Student）否（No）无（No）0": 1900,
          "Early Bird线下（Onsite）学生（Student）否（No）有（Yes）1": 1900,
          "Early Bird线下（Onsite）学生（Student）是（Yes）无（No）0": 1600,
          "Early Bird线下（Onsite）学生（Student）是（Yes）有（Yes）1": 1600,
          "Early Bird线下（Onsite）普通（Regular）否（No）无（No）0": 2400,
          "Early Bird线下（Onsite）普通（Regular）否（No）有（Yes）1": 2400,
          "Early Bird线下（Onsite）普通（Regular）否（No）有（Yes）2": 4800,
          "Early Bird线下（Onsite）普通（Regular）否（No）有（Yes）3": 7200,
          "Early Bird线下（Onsite）普通（Regular）否（No）有（Yes）4": 9600,
          "Early Bird线下（Onsite）普通（Regular）是（Yes）无（No）0": 2100,
          "Early Bird线下（Onsite）普通（Regular）是（Yes）有（Yes）1": 2100,
          "Early Bird线下（Onsite）普通（Regular）是（Yes）有（Yes）2": 2100,
          "Early Bird线下（Onsite）普通（Regular）是（Yes）有（Yes）3": 3100,
          "Early Bird线下（Onsite）普通（Regular）是（Yes）有（Yes）4": 3100,
        },
        standard: {
          "Standard线上（Online）学生（Student）否（No）无（No）0": 0,
          "Standard线上（Online）学生（Student）否（No）有（Yes）1": 1250,
          "Standard线上（Online）学生（Student）是（Yes）无（No）0": 0,
          "Standard线上（Online）学生（Student）是（Yes）有（Yes）1": 950,
          "Standard线上（Online）普通（Regular）否（No）无（No）0": 0,
          "Standard线上（Online）普通（Regular）否（No）有（Yes）1": 1650,
          "Standard线上（Online）普通（Regular）否（No）有（Yes）2": 2500,
          "Standard线上（Online）普通（Regular）否（No）有（Yes）3": 4050,
          "Standard线上（Online）普通（Regular）否（No）有（Yes）4": 9400,
          "Standard线上（Online）普通（Regular）是（Yes）无（No）0": 0,
          "Standard线上（Online）普通（Regular）是（Yes）有（Yes）1": 1350,
          "Standard线上（Online）普通（Regular）是（Yes）有（Yes）2": 1350,
          "Standard线上（Online）普通（Regular）是（Yes）有（Yes）3": 2350,
          "Standard线上（Online）普通（Regular）是（Yes）有（Yes）4": 2350,

          "Standard线下（Onsite）学生（Student）否（No）无（No）0": 2100,
          "Standard线下（Onsite）学生（Student）否（No）有（Yes）1": 2100,
          "Standard线下（Onsite）学生（Student）是（Yes）无（No）0": 1900,
          "Standard线下（Onsite）学生（Student）是（Yes）有（Yes）1": 1900,
          "Standard线下（Onsite）普通（Regular）否（No）无（No）0": 3000,
          "Standard线下（Onsite）普通（Regular）否（No）有（Yes）1": 3000,
          "Standard线下（Onsite）普通（Regular）否（No）有（Yes）2": 6000,
          "Standard线下（Onsite）普通（Regular）否（No）有（Yes）3": 9000,
          "Standard线下（Onsite）普通（Regular）否（No）有（Yes）4": 12000,
          "Standard线下（Onsite）普通（Regular）是（Yes）无（No）0": 2700,
          "Standard线下（Onsite）普通（Regular）是（Yes）有（Yes）1": 2700,
          "Standard线下（Onsite）普通（Regular）是（Yes）有（Yes）2": 2700,
          "Standard线下（Onsite）普通（Regular）是（Yes）有（Yes）3": 3700,
          "Standard线下（Onsite）普通（Regular）是（Yes）有（Yes）4": 3700,
        }

      },
      register_price: '-',
      loading: false,
      iscancle: false,
      waitPay: false,
      nopaidOrder: false,
      nopayinfo: {},
      orderInfo: {},
      localOrder: {}

    };
  },

  watch: {
    serveTime(val) {
      if (val) {
        this.checkTime()
      }
    },
    'form.lucabkzch'() {
      this.wannaCalcPrice()
    },
    'form.b7ih670y2'() {
      this.wannaCalcPrice()
    },
    'form.sxk5r9tdc'() {
      this.wannaCalcPrice()
    },
    'form.iaqclybxj'() {
      this.wannaCalcPrice()
    },
    'form.iaqclzke3'() {
      this.wannaCalcPrice()
    },
    'form.er4evwcmk'() {
      this.wannaCalcPrice()
    },
  },

  computed: {
    payment() {
      let ways = []
      if (this.form.er4evwcmk === '人民币（￥）') {
        if (this.form.wh65wgvx6 === '中国大陆（Mainland China）') {
          ways = [
            'wxpay',
            'alipay',
            'offline'
          ]
        } else {
          ways = [
            'wxpay',
            // 'alipay',
            'offline'
          ]
        }
      } else {
        ways = ['paypal', 'offline']
      }

      return ways
    }
  },

  components: {
    PaymentWay,
    Loading
  },

  methods: {
    // 设置popup挂载点
    getContainer() {
      return document.querySelector('.form_picker_wrap')
    },
    // 点击论文数量
    handlePick() {
      this.ispick = true
    },
    // 取消论文数量选择
    onCancel() {
      this.ispick = false
    },
    // 选择论文数量
    onConfirm(val) {
      this.form.iaqclzke3 = val
      // 处理论文信息
      let len = this.form.koo1lodu.length
      if (val < len) {
        this.form.koo1lodu = this.form.koo1lodu.slice(0, val)
      } else if (val > len) {
        let num = val - len
        for (let i = 1; i <= num; i++) {
          let str = 'paper' + (len + i)
          this.form.koo1lodu.push(ObjectDeepClone(this.org_pagers[str]))
        }
      }
      this.ispick = false
    },
    // 论文是否录用改变
    isManuscriptChange(val) {
      if (val === '有（Yes）') {
        this.form.iaqclzke3 = 1
        // this.form.koo1lodu = []
        this.form.koo1lodu.push(ObjectDeepClone(this.org_pagers.paper1))
      } else {
        this.form.iaqclzke3 = 0
        this.form.koo1lodu = []
      }
      if (this.form.b7ih670y2 == '普通（Regular）') {
        this.options.paper_num = [1, 2, 3, 4]
      } else {
        this.options.paper_num = [1]
      }
    },

    //文件校验
    BeforeImgUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg'
      const isPNG = file.type === 'image/png'

      if (!(isJPG || isPNG)) {
        this.$notify({
          type: 'warning',
          message: '只支持上传.jpg，.jpeg，.png格式的图片!',
        })
      }
      const isLt2M = file.size / 1024 / 1024 < 15
      if (!isLt2M) {
        this.$notify({
          type: 'warning',
          message: '文件大小不能超过 15MB!',
        })
      }
      return (isJPG || isPNG) && isLt2M
    },
    // 上传图片到服务器
    UploadImgToServer(data) {
      let file = new File([data.file], (new Date()).getTime() + '_' + data.file.name, { type: data.file.type })
      this.BeforeUploadAuth(file)
    },
    // 文件上传前鉴权
    BeforeUploadAuth(file) {
      this.uploading = true
      let resdata = {
        module: 'business',
        account_uid: apiObj.VUE_APP_PARAMS.rmb.accountid,
        project_uid: apiObj.VUE_APP_PARAMS.rmb.projectid,
        path: '/form/image/' + file.name,
      }
      UploadAuthentication(resdata)
        .then((res) => {
          const formData = new FormData()
          formData.append('file', file)
          formData.append('policy', res.data.policy)
          formData.append('authorization', res.data.authorization)
          UploadYun(formData)
            .then((res) => {
              this.form.sxk5rg2fh = res.url
              this.fileList.push({ url: apiObj.VUE_APP_BASE_CDN + res.url })
              this.$notify({
                type: 'success',
                message: '文件上传成功！',
              })
              this.uploading = false
            })
            .catch(() => {
              this.uploading = false
            })
        })
        .catch(() => {
          this.uploading = false
        })
    },
    // 点击删除文件
    BeforeImgDelete() {
      this.fileList = []
      this.form.sxk5rg2fh = ''
    },
    // 地址信息发生变化
    addressChanged(val) {
      if (val === '中国大陆（Mainland China）') {
        this.rules.wh63hap7e.required = true
        this.rules.wh63hap7e.error = false
        this.rules.er4ew9r16.required = true
        this.rules.er4ew9r16.error = false
        // this.rules.er4ewaf8w.required = true
        // this.rules.er4ewaf8w.error = false
        // this.rules.pdy81puhb.required = true
        // this.rules.pdy81puhb.error = false
        this.form.lucabkzch = '线下（Onsite）'
      } else {
        this.rules.wh63hap7e.required = false
        this.rules.wh63hap7e.error = false
        this.rules.er4ew9r16.required = false
        this.rules.er4ew9r16.error = false
        this.form.wh63hap7e = ''
        this.form.er4ew9r16 = ''
        // this.rules.er4ewaf8w.required = false
        // this.rules.er4ewaf8w.error = false
        // this.rules.pdy81puhb.required = false
        // this.rules.pdy81puhb.error = false
        // this.form.lucabkzch = '线上（Online）'
      }
    },
    // 是否IEEE会员
    isIeeeMemberChange(val) {
      if (val == '是（Yes）') {
        this.rules.b7ih6a35t.required = true
      } else {
        this.rules.b7ih6a35t.required = false
      }
    },
    // 种类发生变化
    categoryChanged(val) {
      if (val == '学生（Student）') {
        this.rules.sxk5rg2fh.required = true
        this.options.paper_num = [1]
        if (this.form.iaqclybxj == '有（Yes）') {
          this.form.iaqclzke3 = 1
          this.form.koo1lodu = []
          this.form.koo1lodu.push(ObjectDeepClone(this.org_pagers.paper1))
        } else {
          this.form.iaqclzke3 = 0
          this.form.koo1lodu = []
        }
      } else {
        this.rules.sxk5rg2fh.required = false
        this.options.paper_num = [1, 2, 3, 4]
        if (this.form.iaqclybxj == '有（Yes）') {
          this.form.iaqclzke3 = 1
          this.form.koo1lodu = []
          this.form.koo1lodu.push(ObjectDeepClone(this.org_pagers.paper1))
        } else {
          this.form.iaqclzke3 = 0
          this.form.koo1lodu = []
        }
      }
    },
    // 支付币种发生变化
    // currencyChanged(val) {
    //   // console.log(val)
    //   if (val == '人民币（￥）') {
    //     if (this.form.wh65wgvx6 === '中国大陆（Mainland China）') {
    //       this.payment = [
    //         'wxpay',
    //         'alipay',
    //         'offline'
    //       ]
    //     } else {
    //       this.payment = [
    //         'wxpay',
    //         // 'alipay',
    //         'offline'
    //       ]
    //     }

    //   } else {
    //     this.payment = ['paypal', 'offline']
    //   }
    // },
    // 国别区号输入
    countryCodeInp(val) {
      const phoneReg = /^1[3|4|5|6|7|8|9]\d{9}$/
      if (val == '86') {
        if (phoneReg.test(this.form.mobile_phone)) {
          this.rules.mobile_phone.error = false
        } else {
          this.rules.mobile_phone.error = true
        }
      } else {
        this.rules.mobile_phone.error = false
      }
    },
    // 输入手机号
    mobilePhoneInp(val) {
      const phoneReg = /^1[3|4|5|6|7|8|9]\d{9}$/
      if (this.form.country_code == '86') {
        if (phoneReg.test(val)) {
          this.rules.mobile_phone.error = false
        } else {
          this.rules.mobile_phone.error = true
        }
      } else {
        this.rules.mobile_phone.error = false
      }
    },
    // 输入邮箱
    emailInp(val) {
      const emailReg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/
      if (emailReg.test(val)) {
        this.rules.email.error = false
      } else {
        this.rules.email.error = true
      }
    },
    // 关闭支付方式选择
    closePaymentPicker() {
      this.wannapay = false
    },
    // 完成支付方式选择
    pickedPaymentWay(way) {
      this.wannapay = false
      this.dealOrderInfo(way)
    },
    // 整理订单信息
    dealOrderInfo(way) {
      // console.log(way)
      this.dealPaperInfo().then(paperifo => {
        // console.log(paperifo)
        let form_info = ObjectDeepClone(this.form)
        form_info.koo1lodu = paperifo
        this.loading = true
        let data = {
          account_uid: this.form.er4evwcmk == '美元（＄）' ? apiObj.VUE_APP_PARAMS.dollar.accountid : apiObj.VUE_APP_PARAMS.rmb.accountid,
          project_uid: this.form.er4evwcmk == '美元（＄）' ? apiObj.VUE_APP_PARAMS.dollar.projectid : apiObj.VUE_APP_PARAMS.rmb.projectid,
          company_uid: apiObj.VUE_APP_ACCOUNT.companyid,
          channel_uid: apiObj.VUE_APP_ACCOUNT.channelid,
          app_name: this.$AppName,
          payment: way,
          form_data: form_info
        }
        // console.log(data)
        CreateOrder(data).then(res => {
          let tempData = {
            type: `${this.form.er4evwcmk == '美元（＄）' ? 'dollar' : 'rmb'}`,
            accountid: `${this.form.er4evwcmk == '美元（＄）' ? apiObj.VUE_APP_PARAMS.dollar.accountid : apiObj.VUE_APP_PARAMS.rmb.accountid}`,
            projectid: `${this.form.er4evwcmk == '美元（＄）' ? apiObj.VUE_APP_PARAMS.dollar.projectid : apiObj.VUE_APP_PARAMS.rmb.projectid}`,
            orderid: res.data.order_no
          }
          this.$storeLocal.set('ieee_order', tempData)
          // console.log(tempData)
          if (res.code == '10001') {
            // console.log(res)
            this.orderInfo = res
            this.waitPay = true
          } else if (res.code == '60001') { // 0注册费，直接注册成功
            this.$router.push({
              name: 'Result',
              params: {
                type: `${this.form.er4evwcmk == '美元（＄）' ? 'dollar' : 'rmb'}`,
                accountid: `${this.form.er4evwcmk == '美元（＄）' ? apiObj.VUE_APP_PARAMS.dollar.accountid : apiObj.VUE_APP_PARAMS.rmb.accountid}`,
                projectid: `${this.form.er4evwcmk == '美元（＄）' ? apiObj.VUE_APP_PARAMS.dollar.projectid : apiObj.VUE_APP_PARAMS.rmb.projectid}`,
                orderid: res.data.order_no
              }
            })
            this.loading = false
          } else {
            if (way.indexOf('offline') != -1) {
              this.$router.push({
                name: "Result",
                params: {
                  type: `${this.form.er4evwcmk == '美元（＄）' ? 'dollar' : 'rmb'}`,
                  accountid: `${this.form.er4evwcmk == '美元（＄）' ? apiObj.VUE_APP_PARAMS.dollar.accountid : apiObj.VUE_APP_PARAMS.rmb.accountid}`,
                  projectid: `${this.form.er4evwcmk == '美元（＄）' ? apiObj.VUE_APP_PARAMS.dollar.projectid : apiObj.VUE_APP_PARAMS.rmb.projectid}`,
                  orderid: res.data.order_no
                }
              })
            } else {
              this.jumpToPay(res)
            }
          }
        }).catch(() => {
          this.loading = false
        })
      })

    },
    // 整理论文信息
    dealPaperInfo() {
      return new Promise(resolve => {
        if (this.form.koo1lodu.length) {
          let str = ''
          this.form.koo1lodu.map((item, index) => {
            str += `Paper${index} ID: ${item.paperid};报告方式: ${item.format};是否在IEEE刊登: ${item.is_publish};|`
          })
          str = str.substr(0, str.length - 1)
          resolve(str)
        } else {
          resolve('')
        }
      })
    },
    // 继续支付
    wannaPayAgain() {
      this.loading = true
      this.jumpToPay(this.orderInfo)
    },
    // 取消订单
    wannaCancleOrder() {
      this.loading = true
      let data = {
        account_uid: this.form.er4evwcmk == '美元（＄）' ? apiObj.VUE_APP_PARAMS.dollar.accountid : apiObj.VUE_APP_PARAMS.rmb.accountid,
        project_uid: this.form.er4evwcmk == '美元（＄）' ? apiObj.VUE_APP_PARAMS.dollar.projectid : apiObj.VUE_APP_PARAMS.rmb.projectid,
        app_name: this.$AppName,
        order_no: this.orderInfo.data.order_no
      }
      CancleOrder(data).then(res => {
        // console.log(res)
        this.loading = false
        this.$notify({
          type: 'success',
          message: res.msg
        })
      }).catch(() => {
        this.loading = false
      })
    },
    // 前往支付
    jumpToPay(res) {
      let api_url =
        apiObj.VUE_APP_BASE_API +
        '/g/v1/pay/pay?account_uid=' +
        `${this.form.er4evwcmk == '美元（＄）' ? apiObj.VUE_APP_PARAMS.dollar.accountid : apiObj.VUE_APP_PARAMS.rmb.accountid}` +
        '&project_uid=' +
        `${this.form.er4evwcmk == '美元（＄）' ? apiObj.VUE_APP_PARAMS.dollar.projectid : apiObj.VUE_APP_PARAMS.rmb.projectid}` +
        '&order_no=' +
        res.data.order_no +
        '&return_url='
      let return_url =
        apiObj.VUE_APP_BASE_SERVE +
        'custom/ieee2021/result/' +
        `${this.form.er4evwcmk == '美元（＄）' ? 'dollar' : 'rmb'}` +
        '/' +
        `${this.form.er4evwcmk == '美元（＄）' ? apiObj.VUE_APP_PARAMS.dollar.accountid : apiObj.VUE_APP_PARAMS.rmb.accountid}` +
        '/' +
        `${this.form.er4evwcmk == '美元（＄）' ? apiObj.VUE_APP_PARAMS.dollar.projectid : apiObj.VUE_APP_PARAMS.rmb.projectid}` +
        '/' +
        res.data.order_no
      api_url += return_url
      window.location.href = api_url
      // console.log(api_url)
    },
    // 点击支付
    handleWannaPay() {
      // console.log('wanna pay ')
      if (this.pricePrev === 'Not Open') {
        this.$notify({
          type: 'warning',
          message: '注册将于 2021年05月21日 开放'
        })
      } else if (this.pricePrev === 'Closed') {
        this.$notify({
          type: 'warning',
          message: '注册通道已关闭'
        })
      } else {
        this.checkInfoIntegrity().then(() => {
          this.checkPapersInfo().then(() => {
            // console.log('final pass')
            // console.log(this.form)
            this.wannapay = true
          }).catch(msg => {
            this.$notify({
              type: 'warning',
              message: msg
            })
          })
        }).catch(msg => {
          this.$notify({
            type: 'warning',
            message: msg
          })
        })
      }

    },
    // 校验时间
    checkTime() {
      return new Promise((resolve) => {
        let earlyStart = new Date('2021/05/21 00:00:00').getTime()
        // let earlyEnd = new Date('2021/06/21 23:59:59').getTime()
        // let closeEnd = new Date('2021/07/07 23:59:59').getTime()
        let earlyEnd = new Date('2021/08/21 23:59:59').getTime()
        let closeEnd = new Date('2021/10/30 23:59:59').getTime()
        if (this.serveTime - 0 < earlyStart) {
          this.pricePrev = 'Not Open'
          resolve()
        } else if (earlyStart < this.serveTime - 0 && this.serveTime - 0 < earlyEnd) {
          this.pricePrev = 'Early Bird'
          resolve()
        } else if (earlyEnd < this.serveTime - 0 && this.serveTime - 0 < closeEnd) {
          this.pricePrev = 'Standard'
          resolve()
        } else {
          this.pricePrev = 'Closed'
        }
      })
    },
    // 校验数据完整性
    checkInfoIntegrity() {
      return new Promise((resolve, reject) => {
        let keyarr = Object.keys(this.rules)
        try {
          keyarr.forEach((item) => {
            if (this.rules[item].required && !this.form[item].length) {
              throw new Error('您有未完成项目')
            }
            if (this.rules[item].error) {
              throw new Error('请检查您的数据格式')
            }
          })
          resolve()
        } catch (e) {
          if (e.message == '您有未完成项目' || e.message == '请检查您的数据格式') {
            reject(e.message)
          }
        }

      })
    },
    // 校验论文信息
    checkPapersInfo() {
      return new Promise((resolve, reject) => {
        if (this.form.koo1lodu.length == 0) {
          resolve()
        } else {
          try {
            this.form.koo1lodu.forEach((item) => {
              // if (!item.paperid.length || !item.format.length || !item.is_publish.length) {
              if (!item.paperid.length || !item.is_publish.length) {
                throw new Error('您有未完成项目')
              }
            })
            resolve()
          } catch (e) {
            if (e.message == '您有未完成项目') {
              reject(e.message)
            }
          }
        }
      })
    },
    // 计算价格
    wannaCalcPrice() {
      if (this.form.lucabkzch.length > 0 && this.form.b7ih670y2.length > 0 && this.form.sxk5r9tdc.length > 0 && this.form.iaqclybxj.length > 0) {
        // console.log('calc')
        let str = this.pricePrev + this.form.lucabkzch + this.form.b7ih670y2 + this.form.sxk5r9tdc + this.form.iaqclybxj + this.form.iaqclzke3
        // console.log(str)
        let price = 0
        if (this.pricePrev == 'Early Bird') {
          price = this.priceObj.earlyBird[str]
        } else {
          price = this.priceObj.standard[str]
        }
        if (this.form.er4evwcmk == '美元（＄）' && price !== undefined) {
          price = Math.round(price / 6.4)
        }
        if (price !== undefined) {
          this.register_price = this.form.er4evwcmk == '美元（＄）' ? `＄${price}` : `￥${price}`
          console.log(this.register_price)
        }
      }
    },
    // 判断浏览器类型
    // is_weixin() {
    //   let ua = navigator.userAgent.toLowerCase()
    //   if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    //     return true
    //   } else {
    //     return false
    //   }
    // },

    // 初始化查询本地订单状态
    initLocalOrder() {
      let temp = this.$storeLocal.get('ieee_order')
      if (temp && temp.accountid == apiObj.VUE_APP_PARAMS[temp.type].accountid && temp.projectid == apiObj.VUE_APP_PARAMS[temp.type].projectid) {
        this.localOrder = temp
        // 查询订单状态
        this.wannaOrderStatus()
      }
    },
    // 查询订单状态
    wannaOrderStatus() {
      let data = {
        account_uid: this.localOrder.accountid,
        project_uid: this.localOrder.projectid,
        app_name: this.$AppName,
        order_no: this.localOrder.orderid,
      }
      GetOrderStatuscom(data).then(res => {
        let infos = res.data.order
        let time_expire = new Date(infos.create_time).getTime() + 1800000
        let time_current = new Date().getTime()
        if (time_current < time_expire && infos.amount != '0.00' && !infos.paid) {
          this.nopayinfo = infos
          this.nopaidOrder = true
        }
      }).catch(() => { })
    },
    // 继续支付
    wannaPayOrder() {
      if (this.nopayinfo.payment == 'offline') {
        this.$router.push({
          name: 'Result',
          params: {
            type: this.localOrder.type,
            accountid: this.localOrder.accountid,
            projectid: this.localOrder.projectid,
            orderid: this.localOrder.orderid,
          }
        })
      } else {
        this.loading = true
        let api_url =
          apiObj.VUE_APP_BASE_API +
          '/g/v1/pay/pay?account_uid=' +
          this.localOrder.accountid +
          '&project_uid=' +
          this.localOrder.projectid +
          '&order_no=' +
          this.localOrder.orderid +
          '&return_url='
        let return_url =
          apiObj.VUE_APP_BASE_SERVE +
          'custom/ieee2021/result/' +
          this.localOrder.type +
          '/' +
          this.localOrder.accountid +
          '/' +
          this.localOrder.projectid +
          '/' +
          this.localOrder.orderid
        api_url += return_url
        window.location.href = api_url
        // console.log(api_url)
      }

    },
    // 取消订单
    wannaCancelOrder() {
      this.loading = true
      let data = {
        account_uid: this.localOrder.accountid,
        project_uid: this.localOrder.projectid,
        app_name: this.$AppName,
        order_no: this.localOrder.orderid
      }
      CancleOrder(data).then(res => {
        // console.log(res)
        this.loading = false
        this.$notify({
          type: 'success',
          message: res.msg
        })
        this.$storeLocal.set('ieee_order', {
          accountid: '',
          projectid: '',
          type: this.localOrder.type,
          orderid: ''
        })

      }).catch(() => {
        this.loading = false
      })
    }
  },

  mounted() {
    this.initLocalOrder()
  },
}
</script>
<style lang='less' scoped>
.info_form_wrap {
  .info_form_item {
    background: #fff;
    .form_item_name {
      padding: 15px 15px 10px;
      font-size: 14px;
      line-height: 18px;
      font-weight: 500;
      .form_item_name_desc {
        font-size: 12px;
        color: #999;
        display: block;
      }
    }
    .item_need {
      position: relative;
      &::before {
        position: absolute;
        left: 6px;
        color: #ee0a24;
        font-size: 20px;
        content: "*";
        line-height: 26px;
      }
    }
    .form_item_divider {
      width: 100%;
      height: 1px;
      background: #ebedf0;
    }
  }
  // 单选
  .form_radio_group_wrap {
    // padding: 0 15px 10px;
    overflow: hidden;
    .form_radio_item {
      margin: 10px 0;
      /deep/ span.van-radio__label {
        font-size: 14px;
        margin-left: 15px;
        .radio_item_intro {
          font-size: 12px;
          color: #999;
        }
      }
      /deep/.van-radio__icon--checked .van-icon {
        background-color: var(--bgColor);
        border-color: var(--bgColor);
      }
    }
  }
  // 手机号
  .form_phone_num_wrap {
    display: flex;
    padding-left: 16px;
    font-size: 0.37333rem;
    .form_phone_name {
      padding: 10px 0;
      line-height: 24px;
    }
    .form_phone_code {
      width: 70px;
      box-sizing: border-box;
      padding: 10px;
      padding-left: 0;
      &::after {
        border-bottom: 0px !important;
      }

      /deep/input {
        text-align: center !important;
      }
    }
    .form_phone_number {
      flex: 1;
    }
  }
  // tu图片
  .form_upload_img_wrap {
    .business_card_uploader {
      width: 100%;
      position: relative;
    }
    .bcard_preview_load_wrap {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(255, 255, 255, 0.9);
      .bcard_loading {
        position: absolute;
        top: 50%;
        left: 50%;
        min-width: 80px;
        transform: translateX(-50%) translateY(-50%);
        // color: var(--bgColor);
        color: #039;
        .van-loading__text {
          // color: var(--bgColor);
          color: #039;
        }
      }
    }

    /deep/ .van-uploader__upload {
      margin: 0;
    }
    /deep/ .van-uploader__input-wrapper {
      width: 100%;
    }
    /deep/ .van-uploader__preview {
      margin: 0;
      border-radius: 8px;
      background: #f7f8fa;
      width: 100%;
      padding: 5px 0;
    }
    /deep/ .van-uploader__preview-image {
      max-width: 98%;
      width: fit-content;
      margin: 0 auto;
      height: 130px;
    }
    /deep/ .van-image__img {
      width: auto;
    }
    .bcard_upload_btn {
      width: 100%;
      min-height: 140px;
      background: #f7f8fa;
      border-radius: 8px;
      display: flex;
      align-items: center;
      .bcard_upload_btn_body {
        margin: 0 auto;
        padding: 15px;
        text-align: center;
        .bcard_upload_icon {
          font-size: 40px;
        }
        .bcard_upload_tips {
          font-size: 14px;
          line-height: 1.2;
          text-align: justify;
          color: #999;
        }
      }
    }
  }
  // 论文信息
  .paper_info_wrap {
    background: #fff;
    padding: 10px;
    .paper_info_item {
      border: 1px dashed #999;
      border-radius: 5px;
      margin-bottom: 10px;
      background: #f2f5fc;
      padding: 10px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
// 底部内容
.footer_wrap {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  min-height: 60px;
  display: flex;
  background: rgba(255, 255, 255, 0.95);
  box-sizing: border-box;
  padding: 10px 15px;
  box-shadow: 0 4px 12px #069;
  .price_warp {
    flex: 1;
    display: flex;
    font-size: 18px;
    font-weight: 700;
    .price_text {
      line-height: 40px;
    }
    .price_num {
      line-height: 40px;
      flex: 1;
    }
  }
  .footer_btn {
    width: 120px;
    height: 40px;
  }
}
</style>